export const cardTemplates = [
  {
    id: "origin",
    title: "Total GL Balance",
    amtKey: "totalGlBalance",
    descKey: "accountCount",
    suffix: " account(s)",
    className: "bg-blue-50"
  },
  {
    id: "distributed",
    title: "Total Cost Analytics",
    amtKey: "totalCostAnalyticsBalance",
    suffix: "Distribution-side balance",
    className: "bg-violet-50"
  }
];